import { render, staticRenderFns } from "./SpeakerTable.vue?vue&type=template&id=23b539aa&"
import script from "./SpeakerTable.vue?vue&type=script&lang=js&"
export * from "./SpeakerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports